/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronicline.com | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
function calculateMonitorArmStock() {
    // console.log('stock is calculated again!');
    var alreadyClicked = false;
    $(".upsell_cart_item_type_mob_input__js").each(function () {
      if ($(this).closest(".upsell_item_li").attr("style") != "display: none;") {
        if ($(this).closest(".upsell_item_li").hasClass("variantNotInStock")) {
        } else {
          if (alreadyClicked == false) {
            $(this).closest(".upsell_item_li").trigger("click");
            alreadyClicked = true;
          }
        }
      }
    });
    alreadyClicked = false;
    $(".upsell_cart_item_type_2_input__js").each(function () {
      if ($(this).closest(".upsell_item_li").attr("style") != "display: none;") {
        if ($(this).closest(".upsell_item_li").hasClass("variantNotInStock")) {
        } else {
          if (alreadyClicked == false) {
            $(this).closest(".upsell_item_li").trigger("click");
            alreadyClicked = true;
          }
        }
      }
    });
    alreadyClicked = false;
    $(".upsell_cart_item_type_cart_input__js").each(function () {
      // console.log($(this).closest('.upsell_item_li').attr('style'));
      if ($(this).closest(".upsell_item_li").attr("style") != "display: block;") {
        if ($(this).closest(".upsell_item_li").hasClass("variantNotInStock")) {
          console.log("here not");
        } else {
          if (alreadyClicked == false) {
            // console.log($(this).closest('.upsell_item_li').attr('data-name'));
            $(this).closest(".upsell_item_li").trigger("click");
            alreadyClicked = true;
          }
        }
      }
    });
  
    setTimeout(function () {
      $(".upsell_item_li").each(function () {
        if ($(this).find("input:checked").length > 0) {
          $(this).trigger("click");
        }
      });
    }, 100);
  }
  
  $(document).ready(function () {
    var hasOosVariants = 0;
    $(".upsell_item_li").each(function () {
      if ($(this).hasClass("variantNotInStock")) {
        hasOosVariants++;
      }
    });
    if (hasOosVariants != 0) {
      calculateMonitorArmStock();
    }
  });
  
  class CartRemoveButton extends HTMLElement {
    constructor() {
      super();
  
      this.addEventListener("click", (event) => {
        event.preventDefault();
        const cartItems =
          this.closest("cart-items") || this.closest("cart-drawer-items");
        // cartItems.updateQuantity(this.dataset.index, 0);
        var attributeId = $(this).closest(".cart-item").attr("data-id");
        console.log(attributeId, "ATTRIBUTE ID");
        cartItems.removeItem(attributeId, 0);
      });
    }
  }
  
  customElements.define("cart-remove-button", CartRemoveButton);
  

  // --- F4 fix: local fallbacks for legacy globals -------------------------
  if (typeof ON_CHANGE_DEBOUNCE_TIMER === "undefined") {
    var ON_CHANGE_DEBOUNCE_TIMER = 300;
  }
  if (typeof PUB_SUB_EVENTS === "undefined") {
    var PUB_SUB_EVENTS = {
      cartUpdate: "cart-update",
      quantityUpdate: "quantity-update",
      variantChange: "variant-change",
      cartError: "cart-error",
    };
  }
  if (typeof debounce === "undefined") {
    var debounce = function (fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    };
  }
  if (typeof subscribe === "undefined" || typeof publish === "undefined") {
    var _deskCartSubscribers = _deskCartSubscribers || {};
    var subscribe = function (eventName, callback) {
      if (_deskCartSubscribers[eventName] === undefined) {
        _deskCartSubscribers[eventName] = [];
      }
      _deskCartSubscribers[eventName] = [
        ..._deskCartSubscribers[eventName],
        callback,
      ];
      return function unsubscribe() {
        _deskCartSubscribers[eventName] = _deskCartSubscribers[
          eventName
        ].filter((cb) => cb !== callback);
      };
    };
    var publish = function (eventName, data) {
      if (_deskCartSubscribers[eventName]) {
        _deskCartSubscribers[eventName].forEach((callback) => callback(data));
      }
    };
  }
  // -------------------------------------------------------------------------


  class CartItems extends HTMLElement {
    constructor() {
      super();
      this.lineItemStatusElement =
        document.getElementById("shopping-cart-line-item-status") ||
        document.getElementById("CartDrawer-LineItemStatus");
  
      const debouncedOnChange = debounce((event) => {
        if (event.target.type !== "radio") this.onChange(event);
      }, ON_CHANGE_DEBOUNCE_TIMER);
  
      this.addEventListener("change", debouncedOnChange.bind(this));
    }
  
    cartUpdateUnsubscriber = undefined;
  
    connectedCallback() {
      this.cartUpdateUnsubscriber = subscribe(
        PUB_SUB_EVENTS.cartUpdate,
        (event) => {
          if (event.source === "cart-items") {
            return;
          }
          this.onCartUpdate();
        },
      );
    }
  
    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
    }
  
    resetQuantityInput(id) {
      const input = this.querySelector(`#Quantity-${id}`);
      input.value = input.getAttribute("value");
      this.isEnterPressed = false;
    }
  
    setValidity(event, index, message) {
      event.target.setCustomValidity(message);
      event.target.reportValidity();
      this.resetQuantityInput(index);
      event.target.select();
    }
  
    removeQuantity(id, quantity) {
      var currentUrl = String(window.location.href);
      $.ajax({
        type: "POST",
        url: window.Shopify.routes.root + "cart/update.js",
        data: JSON.stringify({ updates: { [id]: quantity } }),
        dataType: "json",
        contentType: "application/json",
        success: function (formData) {
          console.log("Cart updated successfully!", formData);
          const visibleCount = window.deskVisibleCartCount
            ? window.deskVisibleCartCount(formData)
            : formData.item_count;
          const cartCountEl = document.querySelector("#header-icons .cart-button__count");
          if (cartCountEl) {
            cartCountEl.querySelector(".cart-button__count-number").textContent = visibleCount;
            cartCountEl.style.display = visibleCount > 0 ? "flex" : "none";
          }
          deskRefreshCartAfterMutation(formData, function () {
            if (currentUrl.indexOf("cart") != -1) {
              updateCartPage();
            } else {
              updateDrawer();
            }
          });
        },
        error: function (error) {
          console.error("Error updating cart:", error);
        },
      });
    }

    removeItem(id, quantity) {
      var currentUrl = String(window.location.href);
      var data = {
        id: id,
        quantity: 0,
      };
  
      jQuery.ajax({
        type: "POST",
        url: window.Shopify.routes.root + "cart/change.js",
        data: data,
        dataType: "json",
        success: function (cart) {
          deskRefreshCartAfterMutation(cart, function () {
            if (currentUrl.indexOf("cart") != -1) {
              updateCartPage();
            } else {
              updateDrawer();
            }
          });
        },
        error: function () {
          if (currentUrl.indexOf("cart") != -1) {
            updateCartPage();
          } else {
            updateDrawer();
          }
          console.error("Error updating cart:", error);
        },
      });
    }
  
    validateQuantity(event) {
      const inputValue = parseInt(event.target.value);
      const index = event.target.dataset.index;
      let message = "";
  
      if (inputValue < event.target.dataset.min) {
        message = window.quickOrderListStrings.min_error.replace(
          "[min]",
          event.target.dataset.min,
        );
      } else if (inputValue > parseInt(event.target.max)) {
        message = window.quickOrderListStrings.max_error.replace(
          "[max]",
          event.target.max,
        );
      } else if (inputValue % parseInt(event.target.step) !== 0) {
        message = window.quickOrderListStrings?.step_error.replace(
          "[step]",
          event.target.step,
        );
      }
  
      if (message) {
        this.setValidity(event, index, message);
      } else {
        event.target.setCustomValidity("");
        event.target.reportValidity();
  
        var currentId = event.target
          .closest(".cart-item")
          .getAttribute("data-id");
  
        setTimeout(() => {
          const cartItem = event.target.closest(".cart-item");
          var currentQty = event.target
            .closest(".cart-item")
            .querySelector(".quantity__input").value;
  
          if (cartItem) {
            const removeButton = cartItem.querySelector("cart-remove-button");
  
            if (removeButton) {
              removeButton.classList.add("loading");
            }
          }
  
          var items = [];
          items.push({
            id: parseInt(currentId),
            quantity: parseInt(currentQty),
          });
  
          var currentUrl = String(window.location.href);
  
          $.ajax({
            type: "POST",
            url: window.Shopify.routes.root + "cart/update.js",
            data: JSON.stringify({ updates: { [currentId]: currentQty } }),
            dataType: "json",
            contentType: "application/json",
            success: function (formData) {
              console.log("Cart updated successfully!", formData);
              const visibleCount = window.deskVisibleCartCount
                ? window.deskVisibleCartCount(formData)
                : formData.item_count;
              const cartCountEl = document.querySelector("#header-icons .cart-button__count");
              if (cartCountEl) {
                cartCountEl.querySelector(".cart-button__count-number").textContent = visibleCount;
                cartCountEl.style.display = visibleCount > 0 ? "flex" : "none";
              }
              deskRefreshCartAfterMutation(formData, function () {
                if (currentUrl.indexOf("cart") != -1) {
                  updateCartPage();
                } else {
                  updateDrawer();
                }
              });
            },
            error: function (error) {
              console.error("Error updating cart:", error);
              if (currentUrl.indexOf("cart") != -1) {
                updateCartPage();
              } else {
                updateDrawer();
              }
            },
          });
        }, 1000);
      }
    }
  
    onChange(event) {
      this.validateQuantity(event);
    }
  
    onCartUpdate() {
      if (this.tagName === "CART-DRAWER-ITEMS") {
        fetch(`${routes.cart_url}?section_id=cart-drawer`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
            for (const selector of selectors) {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          });
      } else {
        fetch(`${routes.cart_url}?section_id=main-cart-items`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            const sourceQty = html.querySelector("cart-items");
            this.innerHTML = sourceQty.innerHTML;

            // Mirror the section's state classes (e.g. empty_cart-padding)
            // from the freshly rendered markup.
            const newSection = html.querySelector(".cart-section");
            const currentSection = this.closest(".cart-section");
            if (newSection && currentSection) {
              currentSection.className = newSection.className;
            }

            console.log("update2");
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  
    getSectionsToRender() {
      return [
        {
          id: "main-cart-items",
          section: document.getElementById("main-cart-items").dataset.id,
          selector: ".js-contents",
        },
        {
          id: "header-icons",
          section: document.getElementById("header-icons").dataset.id,
          selector: ".js-drawer-open-button-right",
        },
        {
          id: "cart-live-region-text",
          section: "cart-live-region-text",
          selector: ".shopify-section",
        },
      ];
    }
  
    updateQuantity(line, quantity, name, variantId) {
      this.enableLoading(line);
  
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });
  
      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          const quantityElement =
            document.getElementById(`Quantity-${line}`) ||
            document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll(".cart-item");
  
          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute("value");
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }
  
          console.log(parsedState.item_count, "TESTING HERE");
  
          $(".js-drawer-open-button-right").toggleClass(
            "is-empty",
            parsedState.item_count === 0,
          );
          $(this).toggleClass("is-empty", parsedState.item_count === 0);
  
          const visibleCount = window.deskVisibleCartCount
            ? window.deskVisibleCartCount(parsedState)
            : parsedState.item_count;
          const cartCountEl = document.querySelector("#header-icons .cart-button__count");
          if (cartCountEl) {
            cartCountEl.querySelector(".cart-button__count-number").textContent = visibleCount;
            cartCountEl.style.display = visibleCount > 0 ? "flex" : "none";
          }
  
          const cartDrawerWrapper = document.querySelector("cart-drawer");
          const cartFooter = document.getElementById("main-cart-footer");
          const cartPageSection = document.querySelector(".cart-section");

          if (cartFooter)
            cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
          if (cartDrawerWrapper)
            cartDrawerWrapper.classList.toggle(
              "is-empty",
              parsedState.item_count === 0,
            );
          if (cartPageSection)
            cartPageSection.classList.toggle(
              "empty_cart-padding",
              parsedState.item_count === 0,
            );

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document
                .getElementById(section.id)
                .querySelector(section.selector) ||
              document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector,
            );
  
            if (section.id == "main-cart-items") {
              document.querySelector("#main-cart-items .total-block").innerHTML =
                this.getSectionInnerHTML(
                  parsedState.sections[section.section],
                  "#main-cart-items .total-block",
                );
  
              window.cartDrawer.initUpsellCartSlider();
            }
          });
          window.cartDrawer.initUpsellSlider();
          const updatedValue = parsedState.items[line - 1]
            ? parsedState.items[line - 1].quantity
            : undefined;
          let message = "";
          if (
            items.length === parsedState.items.length &&
            updatedValue !== parseInt(quantityElement.value)
          ) {
            if (typeof updatedValue === "undefined") {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace(
                "[quantity]",
                updatedValue,
              );
            }
          }
          this.updateLiveRegions(line, message);
  
          const lineItem =
            document.getElementById(`CartItem-${line}`) ||
            document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(
                  cartDrawerWrapper,
                  lineItem.querySelector(`[name="${name}"]`),
                )
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(
              cartDrawerWrapper.querySelector(".drawer__inner-empty"),
              cartDrawerWrapper.querySelector("a"),
            );
          } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
            trapFocus(
              cartDrawerWrapper,
              document.querySelector(".cart-item__name"),
            );
          }
  
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "cart-items",
            cartData: parsedState,
            variantId: variantId,
          });
        })
        .catch(() => {
          this.querySelectorAll(".loading__spinner").forEach((overlay) =>
            overlay.classList.add("hidden"),
          );
          const errors =
            document.getElementById("cart-errors") ||
            document.getElementById("CartDrawer-CartErrors");
          errors.textContent = window.cartStrings.error;
        })
        .finally(() => {
          this.disableLoading(line);
        });
    }
  
    updateLiveRegions(line, message) {
      const lineItemError =
        document.getElementById(`Line-item-error-${line}`) ||
        document.getElementById(`CartDrawer-LineItemError-${line}`);
      if (lineItemError)
        lineItemError.querySelector(".cart-item__error-text").innerHTML = message;
  
      this.lineItemStatusElement.setAttribute("aria-hidden", true);
  
      const cartStatus =
        document.getElementById("cart-live-region-text") ||
        document.getElementById("CartDrawer-LiveRegionText");
      cartStatus.setAttribute("aria-hidden", false);
  
      setTimeout(() => {
        cartStatus.setAttribute("aria-hidden", true);
      }, 1000);
    }
  
    getSectionInnerHTML(html, selector) {
      if (
        document.querySelector(".mobile-upsells.close") &&
        selector == ".drawer__wrapper"
      ) {
        const parsedDocument = new DOMParser().parseFromString(html, "text/html");
        const newElement = parsedDocument.querySelector(selector);
        newElement.querySelector(".mobile-upsells")?.classList.add("close");
        return newElement.outerHTML;
      }
      return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector).innerHTML;
    }
  
    enableLoading(line) {
      const mainCartItems =
        document.getElementById("main-cart-items") ||
        document.getElementById("CartDrawer-CartItems");
      mainCartItems.classList.add("cart__items--disabled");
  
      const cartItemElements = this.querySelectorAll(
        `#CartItem-${line} .loading__spinner`,
      );
      const cartDrawerItemElements = this.querySelectorAll(
        `#CartDrawer-Item-${line} .loading__spinner`,
      );
  
      [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
        overlay.classList.remove("hidden"),
      );
  
      document.activeElement.blur();
      this.lineItemStatusElement.setAttribute("aria-hidden", false);
    }
  
    disableLoading(line) {
      const mainCartItems =
        document.getElementById("main-cart-items") ||
        document.getElementById("CartDrawer-CartItems");
      mainCartItems.classList.remove("cart__items--disabled");
  
      const cartItemElements = this.querySelectorAll(
        `#CartItem-${line} .loading__spinner`,
      );
      const cartDrawerItemElements = this.querySelectorAll(
        `#CartDrawer-Item-${line} .loading__spinner`,
      );
  
      cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
      cartDrawerItemElements.forEach((overlay) =>
        overlay.classList.add("hidden"),
      );
    }
  }
  
  customElements.define("cart-items", CartItems);
  
  if (!customElements.get("cart-note")) {
    customElements.define(
      "cart-note",
      class CartNote extends HTMLElement {
        constructor() {
          super();
  
          this.addEventListener(
            "input",
            debounce((event) => {
              const body = JSON.stringify({ note: event.target.value });
              fetch(`${routes.cart_update_url}`, {
                ...fetchConfig(),
                ...{ body },
              });
            }, ON_CHANGE_DEBOUNCE_TIMER),
          );
        }
      },
    );
  }
  
  function fetchConfig(type = "json") {
    return {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/${type}`,
      },
    };
  }
  
  function deskRefreshCartAfterMutation(cart, refresh) {
    if (window.deskCartRefreshAfterUpsellPurge) {
      window.deskCartRefreshAfterUpsellPurge(cart, refresh);
      return;
    }

    refresh();
  }

  function updateDrawer() {
    // Fetch only the cart-drawer section (~15KB) instead of the full page (~1–3MB)
    fetch(window.Shopify.routes.root + "?sections=cart-drawer")
      .then((response) => response.json())
      .then((sections) => {
        const html = sections["cart-drawer"];
        if (!html) return;
  
        const doc = new DOMParser().parseFromString(html, "text/html");
        const newDrawer = doc.querySelector("#CartDrawer .drawer__wrapper");
        const currentDrawer = document.querySelector(
          "#CartDrawer .drawer__wrapper",
        );
  
        if (newDrawer && currentDrawer) {
          if (currentDrawer.querySelector(".mobile-upsells.close")) {
            newDrawer.querySelector(".mobile-upsells")?.classList.add("close");
          }
          currentDrawer.innerHTML = newDrawer.innerHTML;
        }
  
        // Update cart count and empty state in background (non-blocking)
        fetch(window.Shopify.routes.root + "cart.js")
          .then((r) => r.json())
          .then((cart) => {
            const visibleCount = window.deskVisibleCartCount
              ? window.deskVisibleCartCount(cart)
              : cart.item_count;
            const el = document.querySelector(
              "#header-icons .cart-button__count",
            );
            if (el) {
              el.querySelector(".cart-button__count-number").textContent = visibleCount;
              el.style.display = visibleCount > 0 ? "flex" : "none";
            }
            const drawerEl = document.querySelector("#cart-drawer");
            if (drawerEl)
              drawerEl.classList.toggle("is-empty", cart.item_count === 0);
          })
          .catch(() => {});
  
        document.querySelector("#cart-drawer").classList.add("active");
        document.body.classList.add("overflow-hidden");
  
        initUpsellSlider();
        calculateMonitorArmStock();
  
        document.dispatchEvent(new CustomEvent("cart:rendered"));
      })
      .catch((error) => console.error("Error Cart Drawer:", error));
  
    setTimeout(function () {
      window.setStockNote?.();
    }, 1000);
  }
  
  function deskCartPageCaptureFocus(section) {
    const active = document.activeElement;
    if (!section || !section.contains(active)) return null;
    const anchor = active.closest("cart-remove-button[id], .cart-item[id], .upsells-cart-list__li[id]");
    return {
      anchorId: anchor ? anchor.id : null,
      isAnchor: anchor === active,
      name: active.getAttribute("name"),
    };
  }

  function deskCartPageRestoreFocus(section, focusState) {
    if (!focusState || !section || section.contains(document.activeElement)) return;
    const anchor = focusState.anchorId && document.getElementById(focusState.anchorId);
    let target = null;
    if (anchor && section.contains(anchor)) {
      if (focusState.isAnchor) target = anchor;
      else if (focusState.name) target = anchor.querySelector(`[name="${CSS.escape(focusState.name)}"]`);
      if (!target && window.DeskA11y) target = window.DeskA11y.getFocusable(anchor)[0];
    }
    const heading = document.getElementById("CartPage-Heading");
    (target || heading)?.focus({ preventScroll: true });
    if (target && heading && window.DeskA11y) window.DeskA11y.announce(heading.textContent.trim());
  }

  function updateCartPage() {
    fetch(window.location.href)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        if (
          window.deskCartUpsellEnforceEligibility &&
          window.deskCartUpsellEnforceEligibility(doc, updateCartPage)
        ) {
          return;
        }

        // Re-render the whole cart section in one go.
        // Safeguarded: only swap when both the fetched and current nodes exist.
        const newSection = doc.querySelector(".cart-section");
        const currentSection = document.querySelector(".cart-section");
        if (newSection && currentSection) {
          const focusState = deskCartPageCaptureFocus(currentSection);
          currentSection.innerHTML = newSection.innerHTML;
          // Keep state classes (e.g. empty_cart-padding) in sync with the
          // freshly rendered markup — innerHTML alone leaves them stale.
          currentSection.className = newSection.className;
          deskCartPageRestoreFocus(currentSection, focusState);
        }

        const newHeaderCarts = doc.querySelectorAll(".desk_header-control__cart");
        document.querySelectorAll(".desk_header-control__cart").forEach((headerCart, index) => {
          if (newHeaderCarts[index]) headerCart.replaceWith(document.adoptNode(newHeaderCarts[index]));
        });

        const cartCount = doc.querySelector(
          "#header-icons .js-drawer-open-button-right",
        );
        const currentCartCount = document.querySelector(
          "#header-icons .js-drawer-open-button-right",
        );
  
        if (cartCount && currentCartCount) {
          currentCartCount.innerHTML = cartCount.innerHTML;
        }
        document.dispatchEvent(new CustomEvent("cart:rendered"));
  
        jQuery.getJSON(window.Shopify.routes.root + "cart.js", function (cart) {
          var cartCounted = cart.item_count;
          if (cartCounted == 0) {
            $("cart-items").addClass("is-empty");
          } else {
            $("cart-items").removeClass("is-empty");
          }
        });
  
        initUpsellCartSlider();
        calculateMonitorArmStock();
      })
      .catch((error) => console.error("Error Cart Drawer:", error));
  }
  
  function initUpsellSlider() {
    new Swiper(".mobile-upsells-swiper", {
      slidesPerView: 1.11,
      spaceBetween: 40,
      loop: false,
      navigation: {
        nextEl: ".drawer__button-next-mob",
        prevEl: ".drawer__button-prev-mob",
      },
      pagination: {
        el: ".drawer .swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + ' bullet">' + "</span>";
        },
      },
    });
  }
  
  function initUpsellCartSlider() {
    window.addOneModalHandler();
    // Upsell list is a plain overflow-x carousel (no Swiper) with prev/next nav.
    initUpsellListNav();
  }

  // Prev/next arrows + edge shadows for the cart-page upsell list carousel.
  function initUpsellListNav() {
    $(".upsells-cart .upsells-cart-list_outer_box").each(function () {
      var $box = $(this);
      var $scroller = $box.find(".upsells-cart-list_outer");
      if (!$scroller.length) return;
      var el = $scroller[0];
      var $next = $box.find('.top-addons-nav_arrow[data="next"]');
      var $prev = $box.find('.top-addons-nav_arrow[data="prev"]');
      var $shadowNext = $box.find(".top-addons-wrapper__side_shadow.right");
      var $shadowPrev = $box.find(".top-addons-wrapper__side_shadow.left");

      // Distance of one card (item stride incl. gap); falls back to viewport width.
      function stride() {
        var items = el.querySelectorAll(".upsells-cart-list__li");
        if (items.length > 1) {
          return (
            items[1].getBoundingClientRect().left -
            items[0].getBoundingClientRect().left
          );
        }
        if (items.length === 1) return items[0].offsetWidth + 16;
        return el.clientWidth;
      }

      function updateNav() {
        var maxScroll = el.scrollWidth - el.clientWidth;
        var noOverflow = maxScroll <= 1;
        var atStart = el.scrollLeft <= 1;
        var atEnd = el.scrollLeft >= maxScroll - 1;
        $prev.toggleClass("disabledNav", noOverflow || atStart);
        $shadowPrev.toggleClass("disabledNav", noOverflow || atStart);
        $next.toggleClass("disabledNav", noOverflow || atEnd);
        $shadowNext.toggleClass("disabledNav", noOverflow || atEnd);
      }

      $next.off("click.upsellnav").on("click.upsellnav", function () {
        el.scrollTo({ left: el.scrollLeft + stride(), behavior: "smooth" });
      });
      $prev.off("click.upsellnav").on("click.upsellnav", function () {
        el.scrollTo({ left: el.scrollLeft - stride(), behavior: "smooth" });
      });
      $scroller.off("scroll.upsellnav").on("scroll.upsellnav", updateNav);
      $(window).off("resize.upsellnav").on("resize.upsellnav", updateNav);

      updateNav();
    });
  }
  
  initUpsellListNav();

  // Cart page quantity +/- handler (mirrors drawer logic)
  (function () {
    var cartPageUpdateTimer;
    $(document).on("click", "#main-cart-items .cart-quantity .quantity__button", function () {
      var $button = $(this);
      var $input = $button.closest(".cart-item-box").find(".quantity__input");
      var variantId = $input.attr("data-quantity-variant-id");

      if (!variantId || !$input.length) return;

      var isPlus = $button.attr("name") === "plus";
      var currentQty = parseInt($input.val(), 10) || 0;
      var newQty = isPlus ? currentQty + 1 : Math.max(0, currentQty - 1);
      $input.val(newQty);

      var $removeButton = $button.closest(".cart-item-box").find("cart-remove-button");
      clearTimeout(cartPageUpdateTimer);
      cartPageUpdateTimer = setTimeout(function () {
        $removeButton.addClass("loading");
        $.ajax({
          type: "POST",
          url: window.Shopify.routes.root + "cart/update.js",
          data: JSON.stringify({ updates: { [variantId]: newQty } }),
          dataType: "json",
          contentType: "application/json",
          success: function (cart) {
            deskRefreshCartAfterMutation(cart, updateCartPage);
          },
        });
      }, 500);
    });
  })();

  // Cart page remove handler (mirrors drawer logic)
  $(document).on("click", "#main-cart-items cart-remove-button .cart-item__remove", function (e) {
    e.preventDefault();
    var href = $(this).attr("data-href");
    if (!href) return;
    var $btn = $(this);
    $btn.closest(".cart-item").addClass("loading");
    $.ajax({
      type: "POST",
      url: href,
      dataType: "json",
      success: function (cart) {
        deskRefreshCartAfterMutation(cart, updateCartPage);
      },
      error: function () {
        $btn.closest(".cart-item").removeClass("loading");
      },
    });
  });

  // Cart page upsell variant selection — covers both desktop (.upsell_cart) and
  // mobile (.upsell_mobile_cart) items (mirrors the cart drawer behaviour).
  $(document).on(
    "click",
    ".upsell_cart__variants .variant:not(.type), .upsell_mobile_cart__variants .variant:not(.type)",
    function () {
      var $el = $(this);
      if ($el.hasClass("variantNotInStock")) return;
      var $container = $el.closest(
        ".upsell_cart__variants, .upsell_mobile_cart__variants",
      );
      var group = $el.data("name")
        ? $container.find(".variant.color[data-name='" + $el.data("name") + "']")
        : $container.find(".variant");
      group.removeClass("active");
      $el.addClass("active");

      var $product = $el.closest(".upsell_cart, .upsell_mobile_cart");

      // Toggle price-block_upsell-item visibility based on variant id
      var variantId = $el.data("variant");
      if (variantId) {
        var $priceBlocks = $product.find(".price-block_upsell-item");
        $priceBlocks.addClass("hided");
        var $matchedBlock = $priceBlocks
          .filter("[data-id='" + variantId + "']")
          .removeClass("hided");

        // Update image from matching price block's data-variant-img
        var variantImg = $matchedBlock.data("variant-img");
        if (variantImg) {
          $product
            .find(
              ".upsell_cart__image-block #upsell_cart_image, .upsell_mobile_cart__image-block #upsell_cart_image",
            )
            .attr("src", variantImg)
            .attr("srcset", variantImg);
        }
      }

      // Update image from swatch data-image (fallback if no price block image)
      var imageSrc = $el.data("image");
      if (imageSrc && !variantId) {
        var $img = $product.find(
          ".upsell_cart__image-block #upsell_cart_image, .upsell_mobile_cart__image-block #upsell_cart_image",
        );
        var currentSrc = $img.attr("src") || "";
        var cdnIndex = currentSrc.indexOf("shop/");
        if (cdnIndex !== -1) {
          $img.attr("src", currentSrc.substring(0, cdnIndex + 5) + imageSrc);
          $img.attr(
            "srcset",
            ($img.attr("srcset") || "").replace(/(shop\/)[^ ]+/g, "shop/" + imageSrc),
          );
        }
      }

      // Update price labels (used by layouts that render a single price block)
      var price = $el.data("price");
      var compared = $el.data("compared");
      var badge = $el.data("badge");
      if (price) $product.find(".price-block__price").html(price);
      if (compared) $product.find(".price-block__sale").html(compared);
      if (badge) $product.find(".price-block__badge").html(badge);
    },
  );

  // Cart page upsell type selection (desktop + mobile)
  $(document).on(
    "click",
    ".upsell_cart__variants .variant.type, .upsell_cart__types .variant.type, .upsell_mobile_cart__variants .variant.type, .upsell_mobile_cart__types .variant.type",
    function () {
      var $el = $(this);
      var $product = $el.closest(".upsell_cart, .upsell_mobile_cart");
      var $colorContainer = $product.find(
        ".upsell_cart__variants, .upsell_mobile_cart__variants",
      );
      var typeName = $el.data("name");

      // Keep the currently selected colour across the type change instead of
      // always snapping back to the first colour.
      var prevColorKey = $colorContainer.find(".variant.color.active").first().data("color");

      $product.find(".variant.type").removeClass("active");
      $el.addClass("active");

      $colorContainer.find(".variant.color").hide().removeClass("active");
      var $group = $colorContainer
        .find(".variant.color[data-name='" + typeName + "']")
        .show();

      // Prefer the same colour in the new type (if it exists and is in stock);
      // otherwise fall back to the first in-stock colour.
      var $inStock = $group.filter(":not(.variantNotInStock)");
      var $match = $();
      if (prevColorKey !== undefined && prevColorKey !== null && prevColorKey !== "") {
        $match = $inStock
          .filter(function () {
            return $(this).data("color") === prevColorKey;
          })
          .first();
      }
      var $first = ($match.length ? $match : $inStock.first()).addClass("active");
      if ($first.length) $first.trigger("click");
    },
  );

  // Cart page upsell add-to-cart (desktop + mobile) — soft re-render afterwards
  $(document).on("click", ".upsell_cart__button", function () {
    var $btn = $(this);
    var $container = $btn.closest(".upsell_mobile_cart, .upsell_cart");
    var $active = $container.find(
      ".variant.color.active, .variant.upsell_item_li.active:not(.type)",
    );
    var variantId = $active.data("variant");
    if (!variantId) return;

    window.deskSetCartAttributes?.();

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function () {
        updateCartPage();
      })
      .catch(function (e) {
        console.error("Upsell add error:", e);
        $content.show();
        $loader.hide();
      });
  });

  